<announcement></announcement>
<app-header *ngIf="translationReady"></app-header>

<div
  [ngClass]="isLoggedInAndCompanySelected ? 'content' : 'content-not-logged-in'"
  *ngIf="show() && translationReady"
  [@routeAnimations]="getRouteAnimationData()">
  <salesforce-migration-notice
    *ngIf="isBlockedBySalesforceMigration; else routeContent"></salesforce-migration-notice>
  <ng-template #routeContent>
    <router-outlet></router-outlet>
  </ng-template>
</div>
<app-footer *ngIf="translationReady"></app-footer>
